var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.9977 0.625C4.05872 0.626108 3.15863 0.998674 2.4946 1.66103C1.83057 2.32339 1.45717 3.22129 1.45605 4.15808C1.45605 7.09339 4.49605 9.79167 4.99772 9.79167C5.49939 9.79167 8.53939 7.09317 8.53939 4.15808C8.53828 3.22138 8.16481 2.32346 7.50084 1.66103C6.83688 0.998608 5.93681 0.626113 4.99774 0.625H4.9977ZM4.9977 2.53473C5.40389 2.53473 5.79344 2.69569 6.08059 2.98224C6.36783 3.2687 6.52918 3.6573 6.52918 4.06251C6.52918 4.46772 6.36783 4.85632 6.08059 5.14278C5.79344 5.42933 5.40389 5.59029 4.9977 5.59029C4.59151 5.59029 4.20196 5.42933 3.91481 5.14278C3.62757 4.85632 3.46622 4.46772 3.46622 4.06251C3.46681 3.65745 3.62834 3.2692 3.9154 2.98283C4.20246 2.69645 4.59166 2.53532 4.9977 2.53473Z",
    fill: "#001F82"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.91504,
    y: 2.5,
    width: 4.16667,
    height: 3.54167,
    fill: "#001F82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker1);
export default __webpack_public_path__ + "static/media/marker1.7f38525f9b5fc8e5bb98e0d97e3dd845.svg";
export { ForwardRef as ReactComponent };